import {
  UserPlus,
  CaretDown,
  Pencil,
  XCircle,
  CheckCircle,
} from 'phosphor-react';
import { Link } from 'react-router-dom';

import React, { useCallback, useEffect, useState } from 'react';
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
} from 'react-bootstrap';
import { FaSearch, FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import ModalAdicionarPromotor from '../ModalAdicionarPromotor';
import { ativarInativarPromotor, buscarPromotores } from '~/Services/Service';
import Loading from '~/Components/Loading';
import { toast } from 'react-toastify';
import { format } from '~/Utils/Helpers';

export default function Promotores() {
  const [promotores, setPromotores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [ordenacao, setOrdenacao] = useState({ campo: 'nome', direcao: 'asc' });
  const [detalhesAbertos, setDetalhesAbertos] = useState({});

  const fetchPromotores = useCallback(async () => {
    try {
      setLoading(true);
      const response = await buscarPromotores();
      setPromotores(response);
    } catch (err) {
      console.error(err);
      toast.error('Falha ao carregar indicadores. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPromotores();
  }, [fetchPromotores]);

  const toggleDetalhes = id => {
    setDetalhesAbertos(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const handleOrdenacao = campo => {
    setOrdenacao(prev => ({
      campo,
      direcao: prev.campo === campo && prev.direcao === 'asc' ? 'desc' : 'asc',
    }));
  };

  const iconeOrdenacao = campo => {
    if (ordenacao.campo !== campo)
      return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc' ? (
      <FaSortUp style={{ marginLeft: 4 }} />
    ) : (
      <FaSortDown style={{ marginLeft: 4 }} />
    );
  };

  const promotoresFiltrados = promotores
    .filter(p => {
      if (busca) {
        const termo = busca.toLowerCase();
        const nome = (p.nome || '').toLowerCase();
        const cel = (p.cel || '').toLowerCase();
        if (!nome.includes(termo) && !cel.includes(termo)) return false;
      }
      if (filtroStatus !== '') {
        if (String(p.status) !== filtroStatus) return false;
      }
      return true;
    })
    .sort((a, b) => {
      const { campo, direcao } = ordenacao;
      let valA = a[campo];
      let valB = b[campo];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return direcao === 'asc' ? -1 : 1;
      if (valA > valB) return direcao === 'asc' ? 1 : -1;
      return 0;
    });

  function getInitials(valor) {
    if (!valor) return '';
    return String(valor)
      .split(' ')[0]
      .substring(0, 1)
      .toUpperCase();
  }

  if (loading) return <Loading />;

  return (
    <>
      <style>{'\
        .promotores-desktop { display: block; }\
        .promotores-mobile { display: none; }\
        .promotores-table th { cursor: pointer; user-select: none; white-space: nowrap; }\
        .promotores-table th:hover { background-color: #f8f9fa; }\
        .promotores-table td { vertical-align: middle; }\
        .promotor-card-mobile { transition: box-shadow 0.2s; }\
        .promotor-card-mobile:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important; }\
        @media (max-width: 768px) {\
          .promotores-desktop { display: none !important; }\
          .promotores-mobile { display: block; }\
        }\
      '}</style>

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center">
            <Col md={4} className="mb-2 mb-md-0">
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="Buscar por nome ou telefone"
                  value={busca}
                  onChange={e => setBusca(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={3} className="mb-2 mb-md-0">
              <Form.Control
                as="select"
                size="sm"
                value={filtroStatus}
                onChange={e => setFiltroStatus(e.target.value)}
              >
                <option value="">Todos os status</option>
                <option value="0">Ativos</option>
                <option value="1">Inativos</option>
              </Form.Control>
            </Col>
            <Col md={5} className="text-right">
              <Link
                to="/indicacao?novo=true"
                className="btn btn-sm btn-success"
              >
                <UserPlus color="white" size={16} style={{ marginRight: 4 }} />
                Novo Indicador
              </Link>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>Indicadores</strong>
          <small>({promotoresFiltrados.length} registros)</small>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="promotores-desktop">
            <table className="table table-striped table-bordered table-hover table-sm mb-0 promotores-table">
              <thead>
                <tr>
                  <th style={{ width: 50 }}></th>
                  <th onClick={() => handleOrdenacao('nome')}>
                    Nome {iconeOrdenacao('nome')}
                  </th>
                  <th onClick={() => handleOrdenacao('cel')} style={{ width: 160 }}>
                    Telefone {iconeOrdenacao('cel')}
                  </th>
                  <th onClick={() => handleOrdenacao('status')} style={{ width: 100 }}>
                    Status {iconeOrdenacao('status')}
                  </th>
                  <th onClick={() => handleOrdenacao('data_hora_criacao')} style={{ width: 120 }}>
                    Criado em {iconeOrdenacao('data_hora_criacao')}
                  </th>
                  <th onClick={() => handleOrdenacao('qtd_indicacoes')} style={{ width: 110 }}>
                    Indicações {iconeOrdenacao('qtd_indicacoes')}
                  </th>
                  <th style={{ width: 100 }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {promotoresFiltrados.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-muted py-3">
                      Nenhum indicador encontrado.
                    </td>
                  </tr>
                ) : (
                  promotoresFiltrados.map(item => (
                    <tr key={item.codigo_usuario}>
                      <td className="text-center">
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            backgroundColor: '#0747a6',
                            color: '#fff',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                          }}
                        >
                          {getInitials(item.nome || item.codigo_usuario)}
                        </div>
                      </td>
                      <td>
                        <strong style={{ color: '#293c66' }}>
                          {item.nome || item.codigo_usuario}
                        </strong>
                      </td>
                      <td>{format.celular(item.cel)}</td>
                      <td>
                        <Badge variant={item.status === 0 ? 'success' : 'secondary'}>
                          {item.status === 0 ? 'Ativo' : 'Inativo'}
                        </Badge>
                      </td>
                      <td>{item.data_hora_criacao}</td>
                      <td className="text-center">
                        <Badge variant="info">{item.qtd_indicacoes}</Badge>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-1">
                          <BotaoEditar item={item} />
                          <BotaoAtivarInativar
                            item={item}
                            setPromotores={setPromotores}
                            promotores={promotores}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="promotores-mobile">
            {promotoresFiltrados.length === 0 ? (
              <div className="text-center text-muted py-3">
                Nenhum indicador encontrado.
              </div>
            ) : (
              promotoresFiltrados.map(item => {
                const aberto = !!detalhesAbertos[item.codigo_usuario];
                return (
                  <Card
                    key={item.codigo_usuario}
                    className="mx-2 mt-2 shadow-sm promotor-card-mobile"
                    style={{
                      borderLeft: `3px solid ${item.status === 0 ? '#28a745' : '#6c757d'}`,
                    }}
                  >
                    <Card.Body className="py-2 px-3">
                      <div className="d-flex align-items-center">
                        <div
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: '50%',
                            backgroundColor: '#0747a6',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            marginRight: 12,
                            flexShrink: 0,
                          }}
                        >
                          {getInitials(item.nome || item.codigo_usuario)}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <strong style={{ color: '#293c66', fontSize: '0.95rem' }}>
                            {item.nome || item.codigo_usuario}
                          </strong>
                          <div className="d-flex align-items-center" style={{ gap: 8 }}>
                            <Badge variant={item.status === 0 ? 'success' : 'secondary'} style={{ fontSize: '0.7rem' }}>
                              {item.status === 0 ? 'Ativo' : 'Inativo'}
                            </Badge>
                            <small className="text-muted">{format.celular(item.cel)}</small>
                          </div>
                        </div>
                        <button
                          onClick={() => toggleDetalhes(item.codigo_usuario)}
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: 4,
                            cursor: 'pointer',
                          }}
                        >
                          <CaretDown
                            size={20}
                            style={{
                              transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)',
                              transition: 'transform 0.3s',
                              color: '#293c66',
                            }}
                          />
                        </button>
                      </div>

                      {aberto && (
                        <div className="mt-2 pt-2" style={{ borderTop: '1px solid #e9ecef' }}>
                          <Row>
                            <Col xs={6} className="mb-2">
                              <small className="text-muted d-block">Criado em</small>
                              <strong style={{ fontSize: '0.85rem' }}>{item.data_hora_criacao}</strong>
                            </Col>
                            <Col xs={6} className="mb-2">
                              <small className="text-muted d-block">Indicações</small>
                              <Badge variant="info">{item.qtd_indicacoes}</Badge>
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-end mt-1" style={{ gap: 8 }}>
                            <BotaoEditar item={item} />
                            <BotaoAtivarInativar
                              item={item}
                              setPromotores={setPromotores}
                              promotores={promotores}
                            />
                          </div>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                );
              })
            )}
          </div>
        </Card.Body>
      </Card>

      <ModalAdicionarPromotor onClose={fetchPromotores} />
    </>
  );
}

const BotaoAtivarInativar = ({ item, setPromotores, promotores }) => {
  return (
    <Button
      size="sm"
      title={item.status === 0 ? 'Inativar' : 'Ativar'}
      variant={item.status === 0 ? 'outline-danger' : 'outline-success'}
      onClick={async () => {
        try {
          await ativarInativarPromotor(
            item.codigo_usuario,
            item.status === 0 ? 1 : 0
          );
          setPromotores(
            promotores.map(p =>
              p.codigo_usuario === item.codigo_usuario
                ? { ...p, status: item.status === 0 ? 1 : 0 }
                : p
            )
          );
          toast.success(
            `Promotor ${item.status === 0 ? 'inativado' : 'ativado'} com sucesso`
          );
        } catch (error) {
          console.error(error);
        }
      }}
    >
      {item.status === 0 ? <XCircle size={16} /> : <CheckCircle size={16} />}
    </Button>
  );
};

const BotaoEditar = ({ item }) => {
  return (
    <Link
      to={`/indicacao?codigo_usuario=${item.codigo_usuario}`}
      className="btn btn-sm btn-outline-primary"
      title="Editar"
    >
      <Pencil size={16} />
    </Link>
  );
};
